/** MiFID performance overlay — four independently switchable white layers + shared notice text. */

export const DEFAULT_MIFID_OVERLAY_NOTICE_TEXT =
  '„Gemäß der EU-Richtlinie ‚MiFID\u2019 (Markets in Financial Instruments Directive) sowie deren Umsetzung in nationales Recht dürfen Angaben zur Wertentwicklung Privatkunden nur dann gezeigt werden, wenn sie sich über einen Zeitraum von mindestens 12 Monaten erstrecken.';

export type SquadMifidOverlayAreaKey =
  | 'coverNavChart'
  | 'coverPerformanceRiskTable'
  | 'coverKalenderjahr'
  | 'coverRollingPerformance';

export type SquadMifidOverlayConfig = {
  noticeText: string;
  coverNavChart: boolean;
  coverPerformanceRiskTable: boolean;
  coverKalenderjahr: boolean;
  coverRollingPerformance: boolean;
};

export const DEFAULT_MIFID_OVERLAY: SquadMifidOverlayConfig = {
  noticeText: DEFAULT_MIFID_OVERLAY_NOTICE_TEXT,
  coverNavChart: false,
  coverPerformanceRiskTable: false,
  coverKalenderjahr: false,
  coverRollingPerformance: false,
};

export const MIFID_OVERLAY_AREA_LABELS: Record<SquadMifidOverlayAreaKey, string> = {
  coverNavChart: 'Page 1 — Wertentwicklung seit Beratungsübernahme (chart)',
  coverPerformanceRiskTable: 'Page 1 — Wertentwicklung und Risikokennzahlen (table)',
  coverKalenderjahr: 'Page 3 — Wertentwicklung je Kalenderjahr',
  coverRollingPerformance: 'Page 3 — Rollierende Wertentwicklung (chart)',
};

export function normalizeMifidOverlay(raw: unknown): SquadMifidOverlayConfig {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_MIFID_OVERLAY };
  const data = raw as Partial<SquadMifidOverlayConfig>;
  const noticeText =
    typeof data.noticeText === 'string' && data.noticeText.trim()
      ? data.noticeText
      : DEFAULT_MIFID_OVERLAY_NOTICE_TEXT;
  return {
    noticeText,
    coverNavChart: Boolean(data.coverNavChart),
    coverPerformanceRiskTable: Boolean(data.coverPerformanceRiskTable),
    coverKalenderjahr: Boolean(data.coverKalenderjahr),
    coverRollingPerformance: Boolean(data.coverRollingPerformance),
  };
}

export function isMifidOverlayActive(
  config: SquadMifidOverlayConfig | undefined,
  area: SquadMifidOverlayAreaKey
): boolean {
  if (!config) return false;
  return Boolean(config[area]);
}
